module.exports = __webpack_public_path__ + "media/images/version_merge/doc_upload_user_error-0fc331bd85a895078ceddf62527091b8.png";